import { render, staticRenderFns } from "./RemoteAssistance.vue?vue&type=template&id=b7d448b8&scoped=true&"
import script from "./RemoteAssistance.vue?vue&type=script&lang=js&"
export * from "./RemoteAssistance.vue?vue&type=script&lang=js&"
import style0 from "./RemoteAssistance.vue?vue&type=style&index=0&id=b7d448b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d448b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSlider})
